// removed by extract-text-webpack-plugin
module.exports = {"links":"index__links___1TkEo","text-btn":"index__text-btn___3Jtgo","single-link":"index__single-link___3QryX","leads-modal":"index__leads-modal___OyP5r","accounts-modal":"index__accounts-modal___cO8OF","opportunities-modal":"index__opportunities-modal___2xkMv","Recently-modal":"index__Recently-modal___2HGxV","Recently-modal-text":"index__Recently-modal-text___2UpbK","Today-modal":"index__Today-modal___1_rCT","viewMore-btn":"index__viewMore-btn___UThkc","Today-modal-text":"index__Today-modal-text___EDod6","Today-modal-number":"index__Today-modal-number___2Gmj8"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Dashboard/components/leftTopModal/index.less
// module id = 288
// module chunks = 3